module.exports = __webpack_public_path__ + "img/358.ff08b4a7.png";